<template>
  <section>
    <div class="header">
      <span>
        <div class="header-box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <div class="title-text"> Hello, {{ profile.displayName | '' }} </div>
                <div class="title-bold"> Transaction History </div>
              </div>
            </div>
            <div class="media-right">
              <figure class="image is-64x64">
                <img v-if=profile.pictureUrl class="is-rounded" :src=profile.pictureUrl alt="Image">
                <img v-else class="is-rounded" src="https://test.iyawat.com/libra-chatbot/nodejs/images/libra-bg.jpg" alt="img" style="width: 50px;    margin: 0 auto;">
              </figure>
            </div>
          </article>
        </div>
      </span>
    </div>
    <div class="body">
      <span>
        <div class="columns">
          <div class="column is-one-fifth"> </div>
          <div class="column is-three-fifths">
            <div class="row">
              <router-link to="/">
                <img src="libra-logo.png" alt="img" style="width: 80%; max-width: 500px; margin: 0 auto;">
              </router-link>
            </div>
            <div class="row">
              <!-- <img :src="wallet.qrcode_url" alt="img" style="width: 80%; max-width: 500px; margin: 0 auto;"> -->
            </div>
            <div class="row">
              <b-message
                :closable="false"
                title="Wallet Address: "
                type="is-info"
                has-icon style="overflow-wrap: break-word;"
              >
                <p v-if="!fetched"> Loading .. </p>
                <p v-if="fetched"> {{ wallet.accountno }} </p>
              </b-message>
            </div>
                <div class="card">
              <div class="address content">
                <div v-if="!fetched"> Loading .. </div>
                <div v-if="fetched" class="align-center">
                  <div
                    v-for="(transaction, index) in transactions"
                    v-bind:key="index"
                    class="transactions-container"
                  >
                    <div class="transactions-header">
                      <div>{{new Date(transaction.date).toUTCString()}}</div>
                      <div class="explorer-container">
                        <a v-bind:href="transaction.explorerLink" target="_blank">
                          Explorer link
                        </a>
                      </div>
                    </div>
                    <div class="transactions-body">
                      <div v-bind:style= "[transaction.event === 'sent' ? {'color': '#483DB1'} : { 'color': '#55C81F' }]">
                        {{ transaction.event.toUpperCase()  }}
                      </div>
                      <div v-bind:style= "[transaction.event === 'sent' ? {'color': '#483DB1'} : { 'color': '#55C81F' }]">
                        {{ Number(transaction.amount).toLocaleString() }} Libra
                      </div>
                    </div>
                    <div v-if="window.width < 600" class="transactions-footer">
                      <div style="color: #7957d5; padding-right: 5px;">
                        {{ transaction.event === 'sent' ? `To: ` : `From: ` }}
                      </div>
                      <div>
                        {{ transaction.event === 'sent' ? shortAddress(transaction.toAddress) : shortAddress(transaction.fromAddress) }}
                      </div>
                    </div>
                    <div v-if="window.width >= 600" class="transactions-footer">
                      <div style="color: #7957d5; padding-right: 5px;">
                        {{ transaction.event === 'sent' ? `To: ` : `From: ` }}
                      </div>
                      <div>
                        {{ transaction.event === 'sent' ? transaction.toAddress : transaction.fromAddress }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="button-box">
                <b-button icon-left="arrow-left" @click="back"> Back </b-button>
              </div>
            </div>

          </div>
          <div class="column is-one-fifth"> </div>
        </div>
      </span>
    </div>
    <FooterBar />
  </section>
</template>

<script>
// require styles
import FooterBar from '@/views/Footer'
import { mapState, mapActions } from 'vuex'
import { ToastProgrammatic as Toast } from 'buefy'
import axios from 'axios'

export default {
  name: 'Transaction',
  components: {
    FooterBar
  },
  data: () => ({
    size: 260,
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    transactions: [],
    fetched: false,
    window: {
      width: 0,
      height: 0
    }
  }),
  filters: {
    numberWithCommas (x) {
      let parts = x.toString().split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return parts.join('.')
    }
  },
  mounted () {
    setTimeout(() => {
      this.getProfile()
      this.queryTransactionHistory(this.wallet.accountno)
    }, 1000)
  },
  computed: {
    ...mapState({
      wallet: state => state.wallet
    }),
    shareUrl () {
      return `http://nav.cx/2EteS7L`
    },
    shareText () {
      return `Hi there, Check out this Line Libra Wallet!
      Please send Libra coin to me at address :
      ${this.wallet.accountno}`
    }
  },
  methods: {
    ...mapActions({
      updateWallet: 'updateWallet'
    }),
    sendMessage () {
      let _this = this
      this.$liff.sendMessages([this.wallet.message[0]])
        .then(function () {
          // alert('Account = ', response.data.accountno)
          _this.$liff.closeWindow()
        }).catch(function (error) {
          Toast.open({
            message: 'Error sending message: ' + error,
            type: 'is-danger'
          })
        })
    },
    getProfile () {
      let _this = this
      this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
      }).catch(function (error) {
        Toast.open({
          message: 'Error getting profile: ' + error,
          type: 'is-danger'
        })
      })
    },
    back () {
      this.$router.push({ name: 'Home' })
    },
    queryTransactionHistory (address) {
      // Get transaction histories from libexplorer
      axios.get('https://libra-chatbot.iyawat.com/queryTrxHistory?address=' + address).then(response => {
        // this.transactions = response.data
        this.transactions = response.data
        this.fetched = true
      }).catch(error => {
        Toast.open({
          message: 'Error query trx ' + error,
          type: 'is-danger'
        })
      })
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    shortAddress (address) {
      const first = address.substr(0, 7)
      const last = address.substr(address.length - 7, address.length)
      return `${first}...${last}`
    }
  }
}
</script>

<style lang="css">
@import 'https://fonts.googleapis.com/css?family=Kanit|Prompt';

  main, html, body {
    font-family: 'Prompt', sans-serif;
    overflow-x: none;
    -webkit-overflow-scrolling: touch;
    background-color: #F4F4F4;
  }
  .header {
    overflow:hidden;
  }
  .header-box {
    background-color: rgb(76, 0, 114);
    border-radius: 0;
    padding: 5% 5% 5% 5%;
  }
  .title-bar {
    background-color: rgb(76, 0, 114);
  }
  .title-text {
    font-size: 20px;
    font-weight: 500;
    color: #fff;
    letter-spacing: .5px;
  }
  .title-bold{
    font-weight: 400;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.801);
    letter-spacing: .5px;
  }

</style>

<style lang="scss" scoped>
  .button-box {
  margin-top: 25px;
  padding: 0 30px;
  button {
    width: 100%;
    height: 60px;
    margin-bottom: 20px;
  }
}
</style>
<style lang="scss">
.card-footer-item {
  padding: 0 !important;
  border: 0 !important;
}
.share-facebook-btn {
  width: 100%;
  button {
    width: 100%;
    height: 60px;
    margin-bottom: 20px;
  }
}
.transaction-container {
  min-height: calc(100vh - 310px);
  width: 100%;
  margin: 0 auto;
}

.transactions-container {
  display: flex;
  flex-direction: column;
  align-self: center;
  height: 60px;
  width: 100%;
  margin-bottom: 10px;
  background-color: #f7f7f7;
  border-radius: 4px;

  .transactions-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30%;
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    font-size: 10px;

    .explorer-container {
      display: flex;
      align-items: center;
    }
  }

  .transactions-body {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-right: 10px;
    padding-left: 10px;
    height: 35%;
    width: 100%;
    font-size: inherit;
    font-weight: bold;
  }

  .transactions-footer {
    display: flex;
    align-items: center;
    padding-left: 10px;
    height: 35%;
    width: 100%;
    font-size: 11px;
  }
}

.wallet-body {
  padding-bottom: 2rem;
  padding-top: 2rem;
}

.card {
  width: 90%;
  margin: 0 auto;
  padding: 20px;
  border-radius: 3px;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.content {
  // max-height: calc(100vh - 450px);
  overflow: auto;

  .align-center {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.address {
  margin-top: 10px;
  overflow-wrap: break-word;
}

.button-box {
  margin-top: 25px;
  padding: 0 30px;
  button {
    width: 100%;
    height: 60px;
    margin-bottom: 20px;
    max-width: 300px;
  }
}
/* on desktop */
@media only screen and (min-width: 1025px) {
  .wallet-container {
    margin: 10px auto;
    width: 70%;
    border-radius: 3px;
  }
  .wallet-body {
    padding-bottom: 6rem;
    padding-top: 6rem;
  }
}
</style>
